export let userRelativeFields = {
    id: "id",
    user_id: "user_id",
    name: "name",
    dob: "dob",
    created_at: "created_at",
    updated_at: "updated_at"
};